import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    formData: {
      l1: [],
      l2: [],
      l3: [],
      vendor: [],
    },
    searchString: '',
  },
  previouslySelectedRow: null,
}

const getSKUsShouldCostFilters = createSlice({
  name: 'sku-list-filters',
  initialState: initialState,
  reducers: {
    setSKUsListFilters: (state, action) => {
      state.filters = action.payload
    },
    resetSKUsFiltersSlice: () => initialState,
    setSKUsListPreviouslySelectedRow: (state, action) => {
      state.previouslySelectedRow = action.payload
    },
  },
})

export const { setSKUsListFilters, resetSKUsFiltersSlice, setSKUsListPreviouslySelectedRow } =
  getSKUsShouldCostFilters.actions

export default getSKUsShouldCostFilters.reducer
